import React,{useRef,useState,useEffect} from 'react';
import styled from 'styled-components'

const Article1Block = styled.div`
    width: 100vw;
    height: 100vh;
    background-image: url('images/wallpaper.jpeg');
    background-position: center;
    background-size: cover ;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        width: 100%;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0,0,0, .5);
        z-index: 0;
    }
    .videoBox {
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        .parent {
            position: relative;
            video {
                width: 80vw;
            }
            .eightBall {
                position: absolute;
                width: 150px;
                bottom: -20px;
                right: -20px;
                animation: Spin 15s linear infinite;
            }
            .logo {
                position: absolute;
                top: -15%; left: -10%; width: 300px;
                transform: rotate(-30deg);
            }
            @keyframes Spin{
                0% {transform:rotate(0deg);}
                100% {transform:rotate(3turn);}
            }
        }
    }
`;

const Article1 = () => {

    // const onload = useRef()
    // const [height,setHeight] = useState()
    // console.log(height)

    // const loadPage = () => {
    //     let sec1height = onload.current.clientHeight
    //     setHeight(sec1height)
    //     console.log(sec1height)
    // }

    // useEffect(
    //     ()=>{
    //         window.addEventListener('resize',loadPage)
    //         return () => window.removeEventListener('resize', loadPage)
    //     },[]
    // )

    // useEffect(
    //     () => {
    //         setHeight(onload.current.clientHeight);
    //     }, []
    // )

    return (
        <Article1Block 
        // ref={onload}
        >
            <div className='videoBox'>
                <div className='parent'>
                    <video playsInline={true} autoPlay={true} loop={true} muted={true}>
                        <source src="videos/Stussy_Spring_2021.mp4" type="video/mp4" />
                    </video>
                    <img className='logo' src="images/stussylogogif.gif" alt='logo'/>
                    <img className='eightBall' src="images/8ball.png" alt='8ball'/>
                </div>
            </div>
        </Article1Block>
    );
};

export default Article1;